gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
// ========================================================================================================== GSAP MATCHMEDIA
let coMM = gsap.matchMedia();
// ========================================================================================================== SMOOTHER
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  coMM.add("(min-width: 750px)", () => {
    ScrollSmoother.create({
      smooth: 0.75,
      effects: false,
      smoothTouch: 0.75 
    });
  });
}